import { render, staticRenderFns } from "./ShowStrategy.vue?vue&type=template&id=77ef3da2&scoped=true&"
import script from "./ShowStrategy.vue?vue&type=script&lang=ts&"
export * from "./ShowStrategy.vue?vue&type=script&lang=ts&"
import style0 from "./ShowStrategy.vue?vue&type=style&index=0&id=77ef3da2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ef3da2",
  null
  
)

export default component.exports